import state from './coupon_state'

const mutations = {
    SET_COUPONS(state, payload) {
        state.coupons = payload
    },
    SET_COUPONS_SUMMARY(state, payload) {
        state.coupons_summary = payload
    }
}

export default mutations
